// extracted by mini-css-extract-plugin
export default {"spin":"Spin_spin__kA9-r","spinning":"Spin_spinning__NGbio"};